// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"54ff94c7","453":"fa8bbe41","455":"6208b2ff","868":"71319258","977":"1ac48273"}[chunkId] + ".chunk.js";
};